import {createReducer, on} from '@ngrx/store';
import {LandEntitiesState} from '../states/land-entities.state';
import {landEntitiesAdapter} from '../adapters/land-entities.adapters';
import {LandEntitiesActions} from '../actions/land-entities.actions';


export const initialLandEntitiesState: LandEntitiesState = landEntitiesAdapter.getInitialState({
  laenderLoaded: false,
  filter: '',
});

export const landEntitiesReducer = createReducer(
  initialLandEntitiesState,

  on(LandEntitiesActions.readLaenderSuccess, (state, {betriebId, landDtos}) => {
    return landEntitiesAdapter.upsertMany(
      landDtos.map(land => ({
        ...land,
        betriebId,
      })),
      {
        ...state,
        laenderLoaded: true,
      },
    );
  }),

  on(LandEntitiesActions.changeLaenderAutocomplete, (state, {filter}) => ({
    ...state,
    filter,
  })),
);
